var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 197,
    height: 94,
    viewBox: "0 0 197 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M98.4994 79.9C116.632 79.9 131.333 65.1698 131.333 47C131.333 28.8302 116.633 14.1 98.4994 14.1C80.366 14.1 65.666 28.8302 65.666 47C65.666 65.1698 80.366 79.9 98.4994 79.9Z",
    fill: "#A70B52"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M106.71 60.7401H98.7264V33.2903H95.7656V63.4486H98.7264V63.4309H106.71V60.7401Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M123.356 48.0489H106.501V45.5336H125.825C125.85 46.0199 125.863 46.507 125.863 46.9999C125.863 62.1422 113.613 74.4166 98.5017 74.4166C83.3909 74.4166 71.1406 62.1422 71.1406 46.9999C71.1406 31.8576 83.3909 19.5833 98.5026 19.5833C98.9009 19.5833 99.2984 19.5915 99.6935 19.609L99.6902 22.1052C99.2946 22.0869 98.8986 22.0777 98.5026 22.0778C84.7665 22.0778 73.6301 33.236 73.6301 46.9999C73.6301 60.7647 84.7657 71.9221 98.5026 71.9221C111.864 71.9221 122.765 61.3647 123.349 48.1194L123.356 48.0489V48.0489Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M88.9206 41.5153C90.0091 41.5153 91.053 41.082 91.8227 40.3108C92.5923 39.5395 93.0247 38.4935 93.0247 37.4028C93.0247 36.3121 92.5923 35.266 91.8227 34.4948C91.053 33.7236 90.0091 33.2903 88.9206 33.2903C87.8321 33.2903 86.7882 33.7236 86.0185 34.4948C85.2488 35.266 84.8164 36.3121 84.8164 37.4028C84.8164 38.4935 85.2488 39.5395 86.0185 40.3108C86.7882 41.082 87.8321 41.5153 88.9206 41.5153V41.5153Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLg);
export default __webpack_public_path__ + "static/media/LG.71d9862a1c786c987f7845aa228e1c20.svg";
export { ForwardRef as ReactComponent };